import Raven from 'raven-js';

Raven.config(
  'https://b72dbc394ad54ac48d59e3cb816a9da7@sentry.io/275599',
).install();

export default Raven;
